module.exports = __webpack_public_path__ + "static/AmnestyTradeGothic-Light-44a110aaca9968a12088349d87e408b1.ttf";